import { css } from 'emotion';

import { colors, icons } from '../styles';

export const breadcrumbs = css`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  position: relative;
`;

export const returnButton = css`
  position: absolute;
  left: 0;
  top: 50%;
  width: ${icons.size.small};
  height: ${icons.size.small};
  color: ${colors.gray.default};
  transform: translateY(-50%) rotate(180deg);
  cursor: pointer;

  &:hover {
    color: ${colors.gray.dark};
  }
`;

export const separator = css`
  width: ${icons.size.smallest};
  height: ${icons.size.smallest};
`;

export const title = css`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const icon = css`
  padding-right: 2px;
`;
